export const UserAppliedOfferStatus = {
  PENDING: "pending",
  APPROVED: "approved",
  DECLINED: "declined",
};
